export default __webpack_public_path__ + "static/media/newsletter7.075f5b89.jpeg";